import axios from '@/util/request'

const baseURL = process.env.VUE_APP_API_URL

export default {
  tiktokGetListings: data => axios({ baseURL, url: '/api/listings/tiktok/listings', method: 'post', data }), // 获取listing列表
  tiktokSyncListings: data => axios({ baseURL, url: '/api/listings/tiktok/syncListings', method: 'post', data }), // 手动同步listing
  tiktokListingDetail: params => axios({ baseURL, url: '/api/listings/tiktok/listingDetail', method: 'get', params }), // 根据id获取listing详情   编辑状态
  tiktokEdit: data => axios({ baseURL, url: '/api/listings/tiktok/listing', method: 'put', data }), // 编辑提交
  tiktokAdd: data => axios({ baseURL, url: '/api/listings/tiktok/listing', method: 'post', data }), // 新增提交
  tiktokGetCategoriesList: params => axios({ baseURL, url: '/api/listings/tiktok/categories', method: 'get', params }), // 获取Categories列表
  tiktokGetCategoryId: data => axios({ baseURL, url: '/api/listings/tiktok/categoryId', method: 'post', data }), // 获取Collection
  tiktokListingStatus: data => axios({ baseURL, url: '/api/listings/tiktok/listingStatus', method: 'put', data }), // 批量上架&上架&批量下架&下架
  tiktokListingDelete: data => axios({ baseURL, url: '/api/listings/tiktok/listings', method: 'delete', data }), // 删除&批量删除Listing

  tiktokListingWarehouses: data => axios({ baseURL, url: '/api/listings/tiktok/warehouses', method: 'post', data }), // 获取仓库列表
  tiktokGetAttributes: params => axios({ baseURL, url: '/api/listings/tiktok/attributes', method: 'get', params }) // 获取品类必填属性列表

}
